// extracted by mini-css-extract-plugin
var _1 = "EmailProfileActionsWidgetNavigation-modulearrows__4cAIx NavArrows-moduleNavArrows__ZbT73";
export { _1 as "arrows" }
